import React, { useEffect, useState } from 'react'
import { useStyles } from '../report.style'
import { FormValues } from '../../store/models/employeeData.model'
import { Paper, Grid, Box } from '@material-ui/core'
import clsx from 'clsx'
import { useSelector } from 'react-redux'
import { IReportsComponent } from '../../store/models'
import { useHistory } from 'react-router'
import { ComplianceTaskListModel } from '../../store/models/complianceTaskListModel'



const EmployeeDataComponent: React.FC = () => {
    const classes = useStyles()
    const reportData: ComplianceTaskListModel = useSelector((state: IReportsComponent) => state.report.tasks)
    const [employees, setEmployees] = useState<FormValues | null>(null);

    const history = useHistory()

    useEffect(() => {
        if (!reportData || !reportData.tasks || reportData.tasks.length === 0) {
            history.push('/')
        } else {
            setEmployees({
                firstName: reportData.personInfo.firstName,
                lastName: reportData.personInfo.lastName,
                logonID: reportData.personID,
            })
        }
    }, [reportData, history])
    

    return (
        <Paper className={clsx(classes.padding, classes.margin)} elevation={6}>
            <Grid container spacing={2} alignItems="flex-end">
                <Grid item md={true} sm={true} xs={true}>
                    <Box textAlign="left"> Name: </Box>
                </Grid>
                <Grid item md={true} sm={true} xs={true}>
                    <Box textAlign="left">
                    {employees ? `${employees.firstName} ${employees.lastName}` : 'N/A'}
                        </Box>
                </Grid>
            </Grid>
            <Grid container spacing={2} alignItems="flex-end">
                <Grid item md={true} sm={true} xs={true}>
                    Logon ID:
                    </Grid>
                <Grid item md={true} sm={true} xs={true}> 
                    <Box textAlign="left">
                        {employees ? employees.logonID : 'N/A'}
                    </Box>
                </Grid>
            </Grid>
        </Paper>
    )
}

export default EmployeeDataComponent